import { SiteConfigState } from '.';
import { DocsPortalStore } from '../../AppStore';
import { createSelector } from '@reduxjs/toolkit';

export const selectSiteConfig = (state: DocsPortalStore) => state.siteConfig;

export const selectSiteLayoutType = createSelector(
  [selectSiteConfig],
  (siteConfigState: SiteConfigState) =>
    siteConfigState.data.viewer.viewerConfig.layoutType,
);

export const selectSiteActiveLayoutType = createSelector(
  [selectSiteConfig],
  (siteConfigState: SiteConfigState) => siteConfigState.data.activeLayoutType,
);

export const selectScrollDirection = createSelector(
  [selectSiteConfig],
  (siteConfigState: SiteConfigState) => siteConfigState.data.scrollDirection,
);
